import fetch from '../utils/fetch'

// 企业微信

// 获取企业微信列表
export function getWorkList (query) {
  return fetch({
    url:'/qywechat/permanentcode/getList',
    method:'get',
    params:query
  })
}

// 编辑企业微信
export function updateWorkConfig (config_id,query) {
  return fetch({
    url:'',
    method:'put',
    params:query
  })
}

// 添加企业微信
export function addWorkConfig (query) {
  return fetch({
    url:'/qywechat/register',
    method:'post',
    params:query
  })
}
// 企业微信部门列表
export function getWorkDep (query) {
  return fetch({
    url:'/qywechat/department/getList',
    method:'get',
    params:query
  })
}
// 获取企业成员列表

export function getEmployee (query) {
  return fetch({
    url:'/qywechat/employee/getList',
    method:'get',
    params:query
  })
}


export function getEmployeeInfo(query) {
  return fetch({
    url:'/qywechat/employee/getinfo',
    method:'get',
    params:query
  })
}
export function deleteEmployeeUser(id) {
  return fetch({
    url:'/qywechat/employee/delete/'+id,
    method:'delete',
  })
}

// 同步企业成员信息
export function getSnyEmployee (query) {
  return fetch({
    url:'/qywechat/employee/syncEmployee',
    method:'get',
    params:query
  })
}
// 同步企业成员信息
export function getSnyDep (query) {
  return fetch({
    url:'/qywechat/department/syncDepartment',
    method:'get',
    params:query
  })
}

// 授权信息
export function getPermanent (query) {
  return fetch({
    url:'/qywechat/permanentcode/list',
    method:'get',
    params:query
  })
}

// 获取第三方应用
export function getThirdList (query) {
  return fetch({
    url:'/qywechat/thirdapp/getlist',
    method:'get',
    params:query
  })
}

// 新增第三方应用
export function addThirdConfig (query) {
  return fetch({
    url:'/qywechat/thirdapp/save',
    method:'post',
    params:query
  })
}

// 编辑第三方应用
export function editThirdConfig (id,query) {
  return fetch({
    url: '/qywechat/thirdapp/edit/'+id,
    method: 'put',
    data: query
  })
}

// 删除第三方应用
export function deleteThirdConfig (id) {
  return fetch({
    url: '/qywechat/thirdapp/delete/'+ id,
    method: 'delete'
  })
}
// 获取企业聊表
export function getCropList (query) {
  return fetch({
    url:'/qywechat/permanentcode/qylist',
    method:'get',
    params:query
  })
}
// 获取分享
export function getShareLog (query) {
  return fetch({
    url:'/qywechat/share/log',
    method:'get',
    params:query
  })
}
//分享数据同步统计
export function getShareSync (query) {
  return fetch({
    url:'/qywechat/share/sync',
    method:'get',
    params:query
  })
}
//获取统计列表
export function getShareDataList (query) {
  return fetch({
    url:'/qywechat/share/getDataList',
    method:'get',
    params:query
  })
}
//导出纷纷向数据
export function getShareExport(query) {
  return fetch({
    url:'/qywechat/share/export',
    method:'get',
    params:query
  })
}
// 编辑授权信息
export function editPementConfig (id,query) {
  return fetch({
    url: '/qywechat/permanentcode/edit/'+id,
    method: 'put',
    data: query
  })
}
// 获取微信客户
export function getWxcustom (query) {
  return fetch({
    url:'/qywechat/contact/getlist',
    method:'get',
    params:query
  })
}
//同步企业客户数据
export function syncContact (query) {
  return fetch({
    url:'/qywechat/contact/syncContact',
    method:'get',
    params:query
  })
}
// 获取微信客户
export function getTaglist (query) {
  return fetch({
    url:'/qywechat/contact_tag/getlist',
    method:'get',
    params:query
  })
}


// 导出成员数据
export function employeeExport (query) {
  return fetch({
    url:'/qywechat/employee/export',
    method:'GET',
    params:query
  })
}

// 获取群发消息
export function getGroupmsg (query) {
  return fetch({
    url:'/qywechat/groupmsg/getlist',
    method:'get',
    params:query
  })
}

// 同步获取群发消息
export function syncGroupmsg (query) {
  return fetch({
    url:'/qywechat/groupmsg/sync',
    method:'get',
    params:query
  })
}
//导出
export function getGroupmsgExport (query) {
  return fetch({
    url:'/qywechat/groupmsg/export',
    method:'get',
    params:query
  })
}
// 获取群发任务列表
export function getTaskList (query) {
  return fetch({
    url:'/qywechat/groupmsg/tasklist',
    method:'get',
    params:query
  })
}

// 获取企业群发成员执行结果
export function getSendList (query) {
  return fetch({
    url:'/qywechat/groupmsg/sendlist',
    method:'get',
    params:query
  })
}


// 同步微信客户群列表
export function getRoomSync (query) {
  return fetch({
    url:'/qywechat/room/getcharlist',
    method:'get',
    params:query
  })
}

// 获取客户群列表
export function getRoomList (query) {
  return fetch({
    url:'/qywechat/room/getlist',
    method:'get',
    params:query
  })
}


// 同步获取朋友圈消息
export function syncMoment (query) {
  return fetch({
    url:'/qywechat/moment/sync',
    method:'get',
    params:query
  })
}
//朋友圈导出
export function getMomentExport (query) {
  return fetch({
    url:'/qywechat/moment/export',
    method:'get',
    params:query
  })
}
// 获取朋友圈列表
export function getMomentList (query) {
  return fetch({
    url:'/qywechat/moment/getlist',
    method:'get',
    params:query
  })
}
// 获取朋友圈列表
export function getMomentTaskList (query) {
  return fetch({
    url:'/qywechat/moment/tasklist',
    method:'get',
    params:query
  })
}

export function setStoreTags (query) {
  return fetch({
    url:'/qywechat/employee/setStoreTags',
    method:'post',
    params:query
  })
}

export function updateUser (query) {
  return fetch({
    url:'/qywechat/employee/update',
    method:'post',
    params:query
  })
}

export function getAllUserIds (query) {
  return fetch({
    url:'/qywechat/getAllUserIds',
    method:'get',
    params:query
  })
}




// WEBPACK FOOTER //
// ./src/api/workwx.js